import { render } from "./TimeSuggestions.vue?vue&type=template&id=2bbb92fa&scoped=true&ts=true"
import script from "./TimeSuggestions.vue?vue&type=script&lang=ts"
export * from "./TimeSuggestions.vue?vue&type=script&lang=ts"

import "./TimeSuggestions.vue?vue&type=style&index=0&id=2bbb92fa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbb92fa"]])

export default __exports__